{
  "$id": "module://job-title",
  "$schema": "wealthlane://schemas/domain",
  "title": "Job Title",
  "description": "Customer job title field catalog",
  "type": "object",
  "properties": {
    "name": {
      "type": "string",
      "title": "Title",
      "widget": "text",
      "noBlank": true,
      "noDoubleSpace": true,
      "maxLength": 100
    },
    "description": {
      "type": "string",
      "title": "Description",
      "widget": "textarea",
      "maxLength": 1000,
      "adapterProps": { "rows": 5 }
    }
  }
}
